import React from 'react';

export class XIcon extends React.Component {

  render() {
    return (
      <svg className={`svg x-icon ${this.props.className || ''}`} onClick={this.props.onClick} width="10px" height="10px" viewBox="0 0 10 10">
        <g id="Sidebar-Menu" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-339.000000, -26.000000)" strokeLinecap="round">
          <g id="Close-2" transform="translate(328.000000, 15.000000)" stroke="#141414" strokeWidth="2">
            <path d="M12,20 L20,12 M12,12 L20,20" id="Stroke-233"></path>
          </g>
        </g>
      </svg>
    )
  }
}